import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
export var userPreferencesPluginKey = new PluginKey('userPreferencesPlugin');
export var createPlugin = function createPlugin(pluginOptions, _api) {
  var userPreferencesProvider = pluginOptions.userPreferencesProvider,
    initialUserPreferences = pluginOptions.initialUserPreferences;
  var getInitialUserPreferences = function getInitialUserPreferences() {
    if (initialUserPreferences && editorExperiment('platform_editor_controls', 'variant1')) {
      return initialUserPreferences;
    }
    return {
      toolbarDockingPosition: 'top'
    };
  };
  return new SafePlugin({
    key: userPreferencesPluginKey,
    state: {
      // @ts-ignore - Workaround for help-center local consumption
      init: function init() {
        return {
          preferences: (userPreferencesProvider === null || userPreferencesProvider === void 0 ? void 0 : userPreferencesProvider.getPreferences()) || getInitialUserPreferences()
        };
      },
      // @ts-ignore - Workaround for help-center local consumption

      apply: function apply(tr, currentPluginState) {
        var meta = tr.getMeta(userPreferencesPluginKey);
        if (meta !== null && meta !== void 0 && meta.preferences) {
          return _objectSpread(_objectSpread({}, currentPluginState), {}, {
            preferences: _objectSpread(_objectSpread({}, currentPluginState.preferences), meta.preferences)
          });
        }
        return currentPluginState;
      }
    }
  });
};